<template>
	<button
		type="button"
		class="
			flex
			justify-center
			items-center
			fixed
			rem:right-[10px]
			z-backdrop
			bg-button-secondary-surface
			hover:bg-button-secondary-surface-hover
			rounded-full
			rem:min-w-[50px]
			rem:h-[50px]
			px-4
			shadow-sm
			transition-all
			group
		"
		:class="chatbot ? 'bottom-20' : 'rem:bottom-[10px]'"
		@mouseleave="visibleText = false"
		@mouseenter="visibleText = true"
		@click="top"
	>
		<Transition
			@enter="enter"
			@leave="leave"
		>
			<span v-if="visibleText" ref="textSpan" class="typo-body-s text-body-important font-bold whitespace-nowrap">
				<span class="pl-1 pr-2">
					<slot />
				</span>
			</span>
		</Transition>
		<NuxtIcon
			name="custom/arrow-up"
			class="text-xl text-icon-primary"
			fill
		/>
	</button>
</template>

<script setup lang="ts">
	import {gsap} from 'gsap';

	const config = useRuntimeConfig();
	const chatbot = config.public.chatbotEnabled;
	const visibleText = ref(false);
	const textSpan = ref<HTMLElement | null>(null);

	function enter(el: gsap.TweenTarget, done: any) {
		const tl = gsap.timeline({onComplete: done});
		tl.fromTo(el, {opacity: 0, width: 0}, {width: textSpan.value?.clientWidth, duration: 0.2})
			.to(el, {opacity: 1, duration: 0.3}, '+=0.1');
	}

	function leave(el: gsap.TweenTarget, done: any) {
		const tl = gsap.timeline({onComplete: done});
		tl.to(el, {opacity: 0, duration: 0.3})
			.to(el, {width: 0, duration: 0.2, onComplete: done});
	}

	function top() {
		gsap.to(window, {scrollTo: 0});
	}
</script>
